import { render, staticRenderFns } from "./FilaAtendimentoHai.vue?vue&type=template&id=a8abe2ba&scoped=true&"
import script from "./FilaAtendimentoHai.vue?vue&type=script&lang=js&"
export * from "./FilaAtendimentoHai.vue?vue&type=script&lang=js&"
import style0 from "./FilaAtendimentoHai.vue?vue&type=style&index=0&id=a8abe2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8abe2ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VProgressCircular,VSkeletonLoader})
